import { Toro } from '../common/enumerations';

export class ControllerStatus
{
    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }

    offlineSince?: string;
    ControllerId?: number;
    ControllerUId?: string;
    DeviceTypeId?: Toro.DeviceType;
    Error?: string;
    IsOnline?: boolean;
    Success?: boolean;
}
